import { render, staticRenderFns } from "./sort-modal.vue?vue&type=template&id=47fd11bc&"
import script from "./sort-modal.vue?vue&type=script&lang=ts&"
export * from "./sort-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports